define([
	"dojo/_base/declare",
	"csi/heading/TextController",
	"SiteAdmin/BusinessObject",
	"SiteAdmin/Locale"
], function(declare,TextController,BusinessObject,Locale) {
	
	var	VALIDATION_PREFIX = "Validation";

	return declare(TextController, {
		toWriter: function() {
			// summary: takes care of renaming of the rule - 
			// the validation error message is removed for the old name and added to the new name
			var	type = BusinessObject.getRootType(this._ctx.getParent());
			var	keys_old = [type, Locale.TYPE_ACTION, VALIDATION_PREFIX + this.oldValue];
			var	keys_new = [type, Locale.TYPE_ACTION, VALIDATION_PREFIX + this.newValue];
			
			// add the validation message to the new name
			Locale.setResource(this.m_writer, Locale.ATTR_TYPES, keys_new, Locale.getTypeAction(keys_old[0], keys_old[2]));
			
			// remove the old name 
			// (setting the value to "" will remove the attribute from the LocaleResources 
		    // see updateLocalization() in com.centricsoftware.pi.model.config.locale.Operation.java) 
			Locale.setResource(this.m_writer, Locale.ATTR_TYPES, keys_old, "");

			this.inherited(arguments);
		}
	});
});